export const ALL_CATEGORIES = { label: 'All categories', value: 'All_CATEGORIES' }

const getMultiselectorOptions = (column, allCategories) => {
    let options = column.options?.map(option => {
        return {
            label: option.label,
            value: option.value
        }
    })

    if (allCategories && column.name === 'related_categories_ids') {
        options = [ALL_CATEGORIES, ...options]
    }

    return options
}

const isAllCategoriesExistsInColumnsValues = columnsValues => {
    if (!columnsValues['related_categories_ids']) {
        return false
    }

    if (typeof columnsValues['related_categories_ids'] === 'string') {
        return columnsValues['related_categories_ids'] === ALL_CATEGORIES.value
    }

    return columnsValues['related_categories_ids']?.some(value => value.value === ALL_CATEGORIES.value)
}

const handleMultiselectorChange = (eventValues, oldValues, columnName) => {
    if (eventValues.length) {
        // if (columnName === 'box_types') {
        //     const boxTypes = eventValues.map(elem => elem)
        //     return {
        //         columnName,
        //         values: boxTypes
        //     }
        // }

        if (columnName === 'related_categories_ids' && [6,7, 8, 9].includes(oldValues['inventory_type']?.value)) {
            // If the user selects ALL_CATEGORIES and the inventory type is Interval Auction
            // We need to set the value to all categories for the selector
            const allCategoriesExistsInChange = eventValues.some(value => value.value === ALL_CATEGORIES.value)
            const allCategoriesExistsInColumnsValues = isAllCategoriesExistsInColumnsValues(oldValues)

            if (allCategoriesExistsInChange && !allCategoriesExistsInColumnsValues) {
                return {
                    columnName,
                    values: [ALL_CATEGORIES]
                }
            } else if (allCategoriesExistsInChange && allCategoriesExistsInColumnsValues) {
                return {
                    columnName,
                    values: [...eventValues.filter(value => value.value !== ALL_CATEGORIES.value)]
                }
            }
        }

        return {
            columnName,
            values: eventValues
        }
    }

    return {
        columnName,
        values: []
    }
}

export { getMultiselectorOptions, isAllCategoriesExistsInColumnsValues, handleMultiselectorChange }
